import { ReactNode } from "react";

export interface IContractorCopy {
  header: ReactNode;
  intro: ReactNode;
  sections: {
    business: {
      title: ReactNode;
      help: ReactNode;
      fields: {
        name: ReactNode;
        years: ReactNode;
        employees: ReactNode;
        tradeType: ReactNode;
      };
    };
    coverage: {
      title: ReactNode;
      help: ReactNode;
      fields: {
        generalLiability: ReactNode;
        workersComp: ReactNode;
        commercialAuto: ReactNode;
      };
    };
    contact: {
      title: ReactNode;
      help: ReactNode;
      fields: {
        firstName: ReactNode;
        lastName: ReactNode;
        email: ReactNode;
        phone: ReactNode;
      };
    };
  };
  buttons: {
    next: ReactNode;
    back: ReactNode;
    submit: ReactNode;
  };
}

export const CONTRACTOR_COPY: IContractorCopy = {
  header: <>🏗 Contractor Insurance Quote</>,
  intro: (
    <>
      Get a free insurance quote tailored for contractors.  
      Please provide your business and coverage details below.
    </>
  ),
  sections: {
    business: {
      title: <>Business Information</>,
      help: <>Tell us about your contracting business.</>,
      fields: {
        name: <>Business Name</>,
        years: <>Years in Business</>,
        employees: <>Number of Employees</>,
        tradeType: <>Type of Trade (e.g., Painting, Plumbing, Electrical)</>,
      },
    },
    coverage: {
      title: <>Coverage Needs</>,
      help: <>Choose the types of insurance coverage you’re interested in.</>,
      fields: {
        generalLiability: <>General Liability</>,
        workersComp: <>Workers’ Compensation</>,
        commercialAuto: <>Commercial Auto</>,
      },
    },
    contact: {
      title: <>Contact Information</>,
      help: <>How should we reach you with your quote?</>,
      fields: {
        firstName: <>First Name</>,
        lastName: <>Last Name</>,
        email: <>Email Address</>,
        phone: <>Phone Number</>,
      },
    },
  },
  buttons: {
    next: <>Next</>,
    back: <>Back</>,
    submit: <>Get My Quote</>,
  },
};
